import React from 'react';

import PropTypes from 'prop-types';

import Crumb from './Crumb';
import CrumbSeparator from './CrumbSeparator';

const Breadcrumbs = ({ crumbs, separator, maxCrumbs }) => {
  if (maxCrumbs && crumbs.length > maxCrumbs) {
    const startIndex = Math.floor(maxCrumbs / 2);
    const endIndex = crumbs.length - Math.ceil(maxCrumbs / 2) - startIndex;
    crumbs.splice(startIndex, endIndex, { text: '...', isOverflow: true });
  }

  return (
    <div className="cr-topbar__breadcrumbs">
      {crumbs.length >= 1
        ? crumbs
            // eslint-disable-next-line react/no-array-index-key
            .map((crumb, index) => <Crumb {...crumb} key={`crumb-${index}`} />)
            .reduce((prev, curr, index) => [
              prev,
              // eslint-disable-next-line react/no-array-index-key
              <CrumbSeparator key={`separator-${index}`}>{separator}</CrumbSeparator>,
              curr,
            ])
        : null}
    </div>
  );
};

Breadcrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      text: PropTypes.node,
      varText: PropTypes.node,
      href: PropTypes.string,
    })
  ).isRequired,
  separator: PropTypes.node.isRequired,
  maxCrumbs: PropTypes.number.isRequired,
};

export default Breadcrumbs;
